module.exports = __webpack_public_path__ + "static/media/ipad_12_9_inch_pro_silver.eceffea2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_12_9_inch_pro_silver.jpeg
// module id = 2104
// module chunks = 0